import styles from "./TestReport.module.less";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useState, useRef, useEffect } from "react";
import CommonNavBar from "views/components/CommonNavBar";
import { getAnswerV3 } from "api/mine";
import { getAppToken } from "api/lesson";
import { Toast } from "react-vant";
import { showMedalShare } from "views/mine/my-medal/MedalShare";
import html2canvas from "html2canvas";
import axios from "axios";

const TestReport = () => {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const [reportData, setReportData] = useState({});
  const [showNav, setShowNav] = useState(false);
  const scrollRef = useRef(null);
  const loadingRef = useRef(null);
  const picRef = useRef(null);

  const _utf8_encode = (string) => {
    string = string.replace(/\r\n/g, "\n");
    var utftext = "";
    for (var n = 0; n < string.length; n++) {
      var c = string.charCodeAt(n);
      if (c < 128) {
        utftext += String.fromCharCode(c);
      } else if (c > 127 && c < 2048) {
        utftext += String.fromCharCode((c >> 6) | 192);
        utftext += String.fromCharCode((c & 63) | 128);
      } else {
        utftext += String.fromCharCode((c >> 12) | 224);
        utftext += String.fromCharCode(((c >> 6) & 63) | 128);
        utftext += String.fromCharCode((c & 63) | 128);
      }
    }
    return utftext;
  };

  const baseCode64 = (input) => {
    var _keyStr =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
    var output = "";
    var chr1, chr2, chr3, enc1, enc2, enc3, enc4;
    var i = 0;
    input = _utf8_encode(input);
    while (i < input.length) {
      chr1 = input.charCodeAt(i++);
      chr2 = input.charCodeAt(i++);
      chr3 = input.charCodeAt(i++);
      enc1 = chr1 >> 2;
      enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
      enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
      enc4 = chr3 & 63;
      if (isNaN(chr2)) {
        enc3 = enc4 = 64;
      } else if (isNaN(chr3)) {
        enc4 = 64;
      }
      output =
        output +
        _keyStr.charAt(enc1) +
        _keyStr.charAt(enc2) +
        _keyStr.charAt(enc3) +
        _keyStr.charAt(enc4);
    }
    return output;
  };

  const handleClickShare = async () => {
    if (picRef.current) {
      showMedalShare(picRef.current, false);
      return;
    }

    loadingRef.current = Toast.loading({
      message: "正在处理图片...",
      forbidClick: false,
      duration: 0,
    });

    const element = document.getElementById("back-box");
    const options = {
      useCORS: true,
      scale: 2,
      logging: false,
      backgroundColor: "#ffffff",
      allowTaint: true,
    };
    try {
      const canvas = await html2canvas(element, options);
      const dataUrl = canvas.toDataURL("image/png");
      const dataBase64 = dataUrl.split(",")[1];
      const tokenRes = await getAppToken();
      if (tokenRes.code === 200) {
        try {
          const phone = JSON.parse(
            localStorage.getItem("userInfo")
          ).phone_number;
          const uploadUrl = `https://up-z1.qiniup.com/putb64/-1/key/${baseCode64(
            `utalkrc/${phone}/${new Date().getTime()}`
          )}`;
          const qiniuRes = await axios.post(uploadUrl, dataBase64, {
            timeout: 30000,
            headers: {
              "Content-Type": "application/octet-stream",
              Authorization: `UpToken ${tokenRes.data}`,
            },
          });
          picRef.current = `https://cdn03.myaitalk.vip/${qiniuRes.data.key}`;
          showMedalShare(picRef.current, false);
          console.log(picRef.current);
        } catch (e) {
          console.log(e);
          toastRef.current.clear();
          return Toast.info("截取图片失败，请重试");
        }
      } else {
        Toast.info("生成分享图片失败，请重试");
      }
    } catch (error) {
      console.log(error);
      Toast.info("截取图片失败，请重试");
    } finally {
      if (loadingRef.current?.clear) {
        loadingRef.current.clear();
        loadingRef.current = null;
      }
    }
  };

  const initData = async () => {
    try {
      loadingRef.current = Toast.loading({
        message: "正在获取报告中...",
        forbidClick: false,
        duration: 0,
      });
      const res = await getAnswerV3(params.get("id"));
      if (res.code === 200) {
        if (params.get("isWx") === "true") {
          if (res.data.message) {
            return Toast.fail(res.data.message);
          }
        }
        if (typeof res.data.created_at === "string") {
          res.data.created_at = res.data.created_at.split(" ")[0];
        }
        setReportData(res.data);
      }
    } catch (error) {
      loadingRef.current.clear();
      loadingRef.current = null;
      Toast.fail("获取报告失败，请返回重试...");
    } finally {
      if (loadingRef.current?.clear) {
        loadingRef.current.clear();
        loadingRef.current = null;
      }
    }
  };

  useEffect(() => {
    if (params.get("isWx") !== "true") {
      setShowNav(true);
    }
    initData();
    return () => {
      if (loadingRef.current?.clear) {
        loadingRef.current.clear();
        loadingRef.current = null;
      }
    };
  }, []);

  return (
    <div className={styles["test-report-container"]} ref={scrollRef}>
      {showNav && (
        <CommonNavBar
          isTop
          noSafe
          backgroundColor={"transparent"}
          onClickBack={() => {
            navigate(-1);
          }}
          leftContent={
            <div
              className={styles["back-box"]}
              onClick={() => {
                navigate(-1);
              }}
            >
              <img
                className={styles["back-box-icon"]}
                src={require("@/images/mine/check-in/back-white.png")}
              />
            </div>
          }
          rightContent={
            <div className={styles["right-box"]}>
              <img
                className={styles["right-box-icon"]}
                src={require("@/images/picture/intro-test/share-icon.png")}
                onClick={handleClickShare}
              />
            </div>
          }
          hideOnScroll
          scrollContainer={scrollRef}
        />
      )}
      <div className={styles["main-container"]} id="back-box">
        <div className={styles["header"]}>
          {reportData.created_at && (
            <div className={styles["header-time"]}>
              {reportData?.created_at}
            </div>
          )}
        </div>
        <div className={styles["content"]}>
          <div className={styles["content-title"]}>
            <span className={styles["content-title-text"]}>学员信息</span>
          </div>
          <div className={styles["content-info"]}>
            <div className={styles["content-info-item"]}>
              <div className={styles["item-title"]}>姓名</div>
              <div className={styles["item-text"]}>
                {reportData?.report?.english_name || "--"}
              </div>
            </div>
            <div className={styles["content-info-item"]}>
              <div className={styles["item-title"]}>年龄</div>
              <div className={styles["item-text"]}>
                {reportData?.report?.age || "--"}
              </div>
            </div>
          </div>
          <div className={styles["content-level"]}>
            <img
              className={styles["content-level-icon"]}
              src={require("@/images/picture/intro-test/teacher-icon-phone.png")}
            />
            <div className={styles["content-level-title"]}>
              {reportData?.report?.category || "--"}
            </div>
            <div className={styles["content-level-text"]}>
              {reportData?.report?.name || "--"}
            </div>
          </div>
          <div className={styles["content-line"]}>
            <div className={styles["content-line-center"]}></div>
          </div>
          <div className={styles["content-title"]}>
            <span className={styles["content-title-text"]}>
              口语课程级别描述
            </span>
          </div>
          <div className={styles["content-word"]}>
            <div className={styles["content-word-item"]}>
              <div className={styles["item-title"]}>活用词汇</div>
              <div className={styles["item-text"]}>
                {reportData?.report?.minWords || "--"}
              </div>
            </div>
            <div className={styles["content-word-item"]}>
              <div className={styles["item-title"]}>认读词汇</div>
              <div className={styles["item-text"]}>
                {reportData?.report?.maxWords || "--"}
              </div>
            </div>
          </div>
          <div className={styles["content-desc"]}>
            <div className={styles["content-desc-title"]}>课程描述：</div>
            <div className={styles["content-desc-text"]}>
              {reportData?.report?.description || "--"}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TestReport;
